import { FormControlLabel as MaterialFormControlLabel } from '@mui/material'

const FormControlLabel = MaterialFormControlLabel

export { FormControlLabel }
